import { exposeDebugInfo } from '~/utils/debug-info';
import { createScopedLogger } from '~/utils/logger';

const logger = createScopedLogger('DiffRecorder');

export interface DiffRecord {
  filePath: string;
  originalFileContent: string;
  diff: string;
}

export type DiffRecordings = DiffRecord[];

export class DiffRecorder {
  #diffs: DiffRecordings = [];
  #currentRecord?: DiffRecord;

  add(filePath: string, originalFileContent: string) {
    this.#currentRecord = { filePath, originalFileContent, diff: '' };
    this.#diffs.push(this.#currentRecord);
  }

  record(filePath: string, diff: string) {
    if (!this.#currentRecord) {
      return;
    }

    if (this.#currentRecord.filePath !== filePath) {
      logger.warn(`Invalid file name, expected '${this.#currentRecord.filePath}'`);
    }

    this.#currentRecord.diff = diff;
  }

  serialize() {
    return JSON.stringify(this.#diffs);
  }
}

export const diffRecorder = new DiffRecorder();

exposeDebugInfo({ diffRecorder });
